import { useDndContext, useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { filter } from "async";
import React from "react";

export default function DraggableWrapper({ id, data, children }) {
  const { active } = useDndContext();
  const isDragging = active?.id === id;

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    data, // ✅ <--- IMPORTANT
  });

  const style = {
    transform: transform ? CSS.Translate.toString(transform) : undefined,
    zIndex: isDragging ? 500 : "auto",
    opacity: isDragging ? 0.75 : 1,
    position: "relative",
    cursor: "grab",
    filter: isDragging
      ? "drop-shadow(0px 8px 20px rgba(0,0,0,0.25)) brightness(1.1) saturate(1.2)"
      : undefined,
    // border: isDragging ? "3px dashed #1890ff" : "",
    // borderRadius: isDragging ? "8px" : "0px"
  };

  return (
    <div
      ref={setNodeRef}
      className="no-select"
      {...listeners}
      {...attributes}
      style={style}
    >
      {children}
    </div>
  );
}
